// extracted by mini-css-extract-plugin
export default {"chatListWrapper":"styles_chatListWrapper__z5Fga","emptyPage":"styles_emptyPage__DqPng","chatList":"styles_chatList__tCUCJ","withOutChats":"styles_withOutChats__GAsHL"};